<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-button class="md-info right-button" @click="open_users_mng">{{$I18n("not_mng")}}</md-button>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <div class="sys_noti_mng">
            <template v-for="(data, index) in datas" >
              <div v-if="index != 0" class="line-bar" :key="data.id+'_line'"></div>
              <div :key="data.id">
                <h3>{{data.name}}</h3>
                <p>{{data.remark}}</p>
                <ul>
                  <li v-for="type in data.push_types" :key="data.id+'_'+type">
                    {{type_name[type]}}：{{
                      data.usersJSON[type]
                        ?data.usersJSON[type].map(i => i.name).join("，")
                        :""
                    }}
                    <div @click="open_edit(data.id, type)">{{$I18n("revise")}}</div>
                  </li>
                </ul>
              </div>
            </template>
            
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal_revise"
      :title = "$I18n('revise')"
      :right = "true"
      @submit= "setting_modal_submit"
    >
      <template slot="body">
        <div>
          <!-- 表单-商品选择-二级商品类型 + 已选择部分 -->
          <md-table class="select-table" :style="{'text-align':'left'}" @md-selected="changeSelect" :md-selected-value.sync="selectData" v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="multiple" md-auto-select>
                  <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('link_id')">{{ item.link_id }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
        </div>
      </template>
    </simple-modal>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal_users"
      :title = "$I18n('user')"
      :large = "true"
      @submit= "() => {}"
    >
      <div slot="body">
        <div class="md-layout card-form" style="max-width: 700px;">
          <!-- 表单-选择框-选择 formValue 查询类型 (1: APP ID, 2: APP名称) -->
          <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
            <md-field>
              <label>{{$I18n('type') }}</label>
              <md-select v-model="userForm.type">
                <md-option :value="0">{{$I18n('all')}}</md-option>
                <md-option :value="2">{{$I18n('email')}}</md-option>
                <md-option :value="3">{{$I18n('sms')}}</md-option>
                <md-option :value="4">{{$I18n('simple_phone')}}</md-option>
                <md-option :value="5">{{$I18n('ent_we_ro')}}</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- 表单-输入框-查询值 (1: APP ID, 2: APP名称) -->
          <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
            <md-field>
              <label>{{$I18n('state') }}</label>
              <md-select v-model="userForm.state">
                <md-option :value="0">{{$I18n('all')}}</md-option>
                <md-option :value="1">{{$I18n('open')}}</md-option>
                <md-option :value="2">{{$I18n('closed')}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-button class= "left-icon md-info" @click="form_search">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
            <md-button class= "left-icon md-info" @click="modal_openModal_add">
              <md-icon>add</md-icon>
              {{$I18n("add")}}
            </md-button>
          </div>
        </div>
        <md-table :style="{'text-align':'left'}" v-model="tableData_user">
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>

            <md-table-cell :md-label="$I18n('link_id')">{{ item.link_id.length > 30 ?item.link_id.substring(0,30) + "..." :item.link_id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('rele_param')">{{ item.link_param }}</md-table-cell>
            <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('operate')" class="button-box" style="width: 160px;">
              <!-- 打开URL  -->
              <table-button @click="modal_openModal_edit(item)" icon="edit" color="md-info" />
              <table-button @click="modal_openModal_del(item)" icon="delete" color="md-danger" />
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
        </md-table>

        <!-- 表格-翻页 -->
        <table-page :total="totalCount_user" :pageSize="pageSize" v-model="pageNo_user"/>
      </div>
    </simple-modal>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal_user_operate"
      :title = "user_operate_title"
      :right = "true"
      @submit= "submitUser"
    >
      <div slot="body">
        <common-form-item 
          v-for="item in form_modalData" 
          v-model="userModifyForm.Form[item.keys]" 
          :error="userModifyForm.Error[item.keys]" 
          :key="item.keys" v-bind="item"
        >
        </common-form-item>
      </div>
    </simple-modal>
    <simple-modal 
      ref    = "modal_user_delete"
      :title = "user_operate_title"
      @submit= "submitUser"
    >
      <div slot="body">{{$I18n("check_delete", userModifyForm.Form.name)}}</div>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass, timestampToString1000 } from "@/common/tools.js";
export default {
  props: ["userinfo_sys"],
  data() {
    return {
      datas: [], // 外部Data
      type: "",
      id  : "",
      selectData: [],
      tableData : [],

      type_name : ["", this.$I18n("app_not"), this.$I18n("simple_email"), this.$I18n("sms"), this.$I18n("simple_phone"), this.$I18n("ent_we_ro")],
      userForm: {
        type: 0,
        state:0,
      },
      userSearchForm:{
        type: 0,
        state:0,
      },
      userModifyForm: new FormClass({ // 弹窗-弹窗表单数据
        type: 2,
        state:1,
        link_param:"",
        name: {
          init: "",
          check:"required",
        },
        link_id: {
          init: "",
          check:"required",
        },
      }),
      pageSize: 10,
      row_tableData_user: [],
      totalCount_user: 0,
      pageNo_user: 1,
      user_operate_title:"",
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    pageNo_user(){
      this.api_getUserdata();
    },
  },
  computed: {
    form_modalData(){
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          options : [
            {id: "2", name : this.$I18n("email")},
            {id: "3", name : this.$I18n("sms")},
            {id: "4", name : this.$I18n("simple_phone")},
            {id: "5", name : this.$I18n("ent_we_ro")},
          ],
          required: true,
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          options : [
            {id: "1", name : this.$I18n("open")},
            {id: "2", name : this.$I18n("closed")},
          ],
          required: true,
        },{
          label   : this.$I18n("rele_param"),
          keys    : "link_param",
          type    : "input",
        },{
          label   : this.$I18n("link_id"),
          keys    : "link_id",
          type    : "input",
          required: true,
          check   : true,
        }
      ]
    },
    tableData_user(){
      return this.row_tableData_user.map(i => {
        let type_name = this.$I18n("unknow")
        switch(i.type){
          case 2: 
            type_name = this.$I18n("email");
            break;
          case 3: 
            type_name = this.$I18n("sms");
            break;
          case 4: 
            type_name = this.$I18n("simple_phone");
            break;
          case 5: 
            type_name = this.$I18n("ent_we_ro");
            break;
        }

        let state_name = this.$I18n("unknow")
        switch(i.state){
          case 1: 
            state_name = this.$I18n("open");
            break;
          case 2: 
            state_name = this.$I18n("closed");
            break;
        }
        return {
          ...i,
          type_name,
          state_name,
          create_time: timestampToString1000(i.gmt_create),
          update_time: timestampToString1000(i.gmt_update),
        }
      });
    },
  },
  methods: {
    submitUser(){
      if(this.user_operate_title == this.$I18n("delete")){
        return this.$api.delNotiUser(this.userModifyForm.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("delete_success"));
            this.$refs.modal_user_delete.close();
            this.api_getUserdata();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      }
      if(this.userModifyForm.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      if(this.user_operate_title == this.$I18n("add")){
        return this.$api.addNotiUser(this.userModifyForm.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("add_success"));
            this.$refs.modal_user_operate.close();
            this.api_getUserdata();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      }else if(this.user_operate_title == this.$I18n("edit")){
        return this.$api.setNotiUser(this.userModifyForm.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
            this.$refs.modal_user_operate.close();
            this.api_getUserdata();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      }
    },
    modal_openModal_add(){
      this.user_operate_title = this.$I18n("add");
      this.userModifyForm.Reset();
      this.$refs.modal_user_operate.open();
    },
    modal_openModal_edit(item){
      this.user_operate_title = this.$I18n("edit");
      this.userModifyForm.Update(item);
      this.$refs.modal_user_operate.open();
    },
    modal_openModal_del(item){
      this.user_operate_title = this.$I18n("delete");
      this.userModifyForm.Update(item);
      this.$refs.modal_user_delete.open();
    },
    form_search(){
      this.pageNo_user = 1;
      this.userSearchForm = {...this.userForm}
      this.api_getUserdata();
    },
    // 打开角色弹窗
    open_users_mng(){
      this.pageNo_user = 1;
      this.userForm = {
        type: 0,
        state:0,
      }
      this.userSearchForm = {
        type: 0,
        state:0,
      }
      this.api_getUserdata().then(() => {
        this.$refs.modal_users.open();
      })
    },
    // 打开配置弹窗
    open_edit(id, type){
      this.id  = id;
      this.type= type;
      this.api_getNotiUser()
        .then(() => {
          this.$refs.modal_revise.open();
        })
    },
    api_getUserdata(){
      return this.$api.getNotiUser({
        ...this.userSearchForm,
        page_no: this.pageNo_user,
        page_size: this.pageSize,
      })
        .then(this.$Then(res => {
          this.row_tableData_user = res.data;
          this.totalCount_user = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.row_tableData_user = [];
          this.totalCount_user = 0;
        }))
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getSysNotSet({ })
        .then(this.$Then(res => {
          this.datas = res.data.map(i => {
            var usersJSON = {};
            if(i.users && i.users.length > 0){
              i.users.forEach(user => {
                if(usersJSON[user.type]){
                  usersJSON[user.type].push(user)
                } else {
                  usersJSON[user.type] = [user]
                }
              })
            }
            return {
              ...i,
              usersJSON,
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.datas = [];
        }))
    },
    api_getNotiUser(){
      return this.$api.getNotiUser({
        type: this.type,
      })
        .then(this.$Then(res => {
          this.tableData = res.data;
          const selectedList = this.datas.filter(i => i.id === this.id)[0].usersJSON[this.type]
          const selected = selectedList ?selectedList.map(i => i.id) :[];
          if(selected){
            this.selectData = res.data.filter(i => selected.includes(i.id));
          } else {
            this.selectData = [];
          }
          
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableData = [];
          this.selectData = [];
        }))
    },
    changeSelect (item){ // 表格-选择云存储
      this.selectData = item;
    },
    // 提交表单
    setting_modal_submit () {
      this.$api.setSysNotSet({
        id   : this.id,
        type : this.type,
        users: this.selectData.map(i => {
          return {id: i.id}
        }),
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.modal_revise.close();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
}
</script>
<style lang="scss" scoped>
  h3{
    font-size: 1.5625rem;
    line-height: 1.4em;
    margin: 20px 0 10px;
    font-weight: 600;
  }
  .sys_noti_mng li div{
    display: inline-block; 
    color: #00bcd4; 
    font-weight: 600;
    cursor: pointer;
    margin:0 -5px 0 5px; 
    padding:0 5px;
  }
  .sys_noti_mng li{
    height: 30px;
    line-height: 30px;
  }
  .sys_noti_mng ul{
    padding-left: 20px;
  }
  .sys_noti_mng>div{
    padding:0 10px;
    width: 100%;
  }
  .sys_noti_mng>div.line-bar{
    padding:0px;
    width: calc(100% + 30px); 
    height: 1px;
    background: #BBBBBB;
    margin: 0 -15px;
  }
  .select-table{
    & .md-selected{
      background-color: unset !important;
    }
  }


  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>